import { render, staticRenderFns } from "./Structures.vue?vue&type=template&id=5204848b&scoped=true"
import script from "./Structures.vue?vue&type=script&lang=ts"
export * from "./Structures.vue?vue&type=script&lang=ts"
import style0 from "./Structures.vue?vue&type=style&index=0&id=5204848b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204848b",
  null
  
)

export default component.exports